import { useLayoutEffect } from 'react';
import { useLocation } from 'utils/router';
import { useNavigationType } from 'react-router-dom';

const scrollPositions = new Map();

const getRoot = () => document.getElementById('content');

function useScrollRestoration() {
  const location = useLocation();
  const navigationType = useNavigationType(); // POP, PUSH, REPLACE

  useLayoutEffect(() => {
    const key = location.pathname;

    if (['POP', 'PUSH'].includes(navigationType)) {
      const y = scrollPositions.get(key);
      if (y !== undefined) {
        getRoot()?.scrollTo(0, y);
      }
    } else {
      // New navigation -> scroll to top
      getRoot()?.scrollTo(0, 0);
    }

    return () => {
      let root = getRoot();

      if (root !== null) {
        scrollPositions.set(key, root.scrollTop);
      }
    };
  }, [location, navigationType]);
}

const ScrollReset = () => {
  useScrollRestoration();

  return null;
};

export default ScrollReset;
